import { unsafeCSS } from 'lit'


export const webfontBaseUrl = unsafeCSS`https://s3-cdn.cloudsuite.com/font-awesome/6.5.1-web/webfonts`
